// src/components/Navbar.js
import React, { useState } from 'react';
import { Menu, X } from 'lucide-react'; // Import necessary icons

function Navbar({ companyName, logoUrl }) {
  const [isOpen, setIsOpen] = useState(false);

  // Define styles for better readability (consider moving to CSS modules or styled-components later)
  const navLinkStyle = "text-gray-300 hover:bg-slate-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out";
  const mobileNavLinkStyle = "text-gray-300 hover:bg-slate-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium transition duration-150 ease-in-out";
  const ctaButtonStyle = "bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out";
  const mobileCtaButtonStyle = "bg-indigo-600 hover:bg-indigo-700 text-white block px-3 py-2 rounded-md text-base font-medium transition duration-150 ease-in-out";

  return (
    <nav className="py-4 bg-slate-800/90 backdrop-blur-sm text-white shadow-md sticky top-0 z-50">
      <div className=" max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand Name */}
          <div className="flex-shrink-0 flex items-center">
            <div className="">
              {/* Use the logoUrl prop which now contains the imported image */}
              <img
                className="w-20 h-20 rounded-full border-2 border-cyan-950 mr-5"
                src={logoUrl}
                alt={`${companyName} Logo`}
                // Basic error handling (might hide if src is invalid)
                onError={(e) => e.target.style.display = 'none'}
              />
            </div>
            {/* Company Name with serif font */}
            <span className="text-2xl font-bold text-white">{companyName}</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              <a href="#home" className={navLinkStyle}>Home</a>
              <a href="#capabilities" className={navLinkStyle}>Capabilities</a>
              <a href="#products-services" className={navLinkStyle}>Products & Services</a>
              <a href="#about" className={navLinkStyle}>About Us</a>
              <a href="#contact" className={ctaButtonStyle}>Contact</a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="bg-slate-700 inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-800 focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" aria-hidden="true" /> : <Menu className="block h-6 w-6" aria-hidden="true" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`} id="mobile-menu">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-slate-800/95">
          {/* Close menu on link click */}
          <a href="#home" className={mobileNavLinkStyle} onClick={() => setIsOpen(false)}>Home</a>
          <a href="#capabilities" className={mobileNavLinkStyle} onClick={() => setIsOpen(false)}>Capabilities</a>
          <a href="#products-services" className={mobileNavLinkStyle} onClick={() => setIsOpen(false)}>Products & Services</a>
          <a href="#about" className={mobileNavLinkStyle} onClick={() => setIsOpen(false)}>About Us</a>
          <a href="#contact" className={mobileCtaButtonStyle} onClick={() => setIsOpen(false)}>Contact</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
